export class UserFilter {
  name?: string;
  visible?: boolean;
}
